import React from 'react'
import '../Css/PolicyStyle.css'
import Navbar from './Navbar';
import '../Css/NavbarStyle.css'

const Policy = () => {
  return (
    <div>
      <Navbar/>
      <div className="policyFullPage">
        <div className="text-center "><h1>Our Company Policy</h1></div>
        <p>1. Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis accusamus molestiae repellat eum unde ad a enim! Mollitia, error pariatur.</p>
        <p>2. Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis accusamus molestiae repellat eum unde ad a enim! Mollitia, error pariatur.</p>

        <p>3. Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis accusamus molestiae repellat eum unde ad a enim! Mollitia, error pariatur.</p>

        <p>4. Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis accusamus molestiae repellat eum unde ad a enim! Mollitia, error pariatur.</p>
        <p>5. Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis accusamus molestiae repellat eum unde ad a enim! Mollitia, error pariatur.</p>
        <p>6. Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis accusamus molestiae repellat eum unde ad a enim! Mollitia, error pariatur.</p>
        <p>7. Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis accusamus molestiae repellat eum unde ad a enim! Mollitia, error pariatur.</p>
        <p>8. Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis accusamus molestiae repellat eum unde ad a enim! Mollitia, error pariatur.</p>
        <p>9. Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis accusamus molestiae repellat eum unde ad a enim! Mollitia, error pariatur.</p>
        <p>10. Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis accusamus molestiae repellat eum unde ad a enim! Mollitia, error pariatur.</p>
        <p>11. Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis accusamus molestiae repellat eum unde ad a enim! Mollitia, error pariatur.</p>
        <p>12. Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis accusamus molestiae repellat eum unde ad a enim! Mollitia, error pariatur.</p>
        <p>13. Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis accusamus molestiae repellat eum unde ad a enim! Mollitia, error pariatur.</p>

      </div>
    </div>
  )
}

export default Policy
